/**
 * Created by mfr on 2018-05-29.
 *
 * These icon URLs are persisted verbatim into customer data
 * (PlanOrderStoreyFileRevision.FabricJsContent) when an annotation canvas is
 * saved and are resolved again on every later load, so they must outlive every
 * deploy. Keep them as stable, hash-free paths under /images/ (served verbatim
 * from app/assets/images) — never require() them through the bundler, which
 * emits content-hashed filenames that change between deploys.
 *
 * The icon set is append-only: changed artwork gets a new filename; never
 * change or delete the file behind an existing name, or previously saved
 * canvases will render differently or lose objects.
 * See desicions/2026-06-12_stable_plan_annotation_icon_urls.md.
 */

let DragSourcesCorr = {},
    SourcesBathroom = {},
    SourcesIndoors = {},
    SourcesKitchen = {},
    SourcesStairs = {};

// Bathroom

SourcesBathroom['Bathtub'] = '/images/plan-annotation-corr/Bathroom/Bathtub-red.svg';
SourcesBathroom['Bidet'] = '/images/plan-annotation-corr/Bathroom/Bidet-red.svg';
SourcesBathroom['CornerBathtub'] = '/images/plan-annotation-corr/Bathroom/Corner-bathtub-red.svg';
SourcesBathroom['DryerWasherPillar'] =
    '/images/plan-annotation-corr/Bathroom/Dryer-washer-pillar-red.svg';
SourcesBathroom['DryerWasher'] = '/images/plan-annotation-corr/Bathroom/Dryer-washer-red.svg';
SourcesBathroom['DryingCabinet'] = '/images/plan-annotation-corr/Bathroom/Drying-cabinet-red.svg';
SourcesBathroom['DualSink'] = '/images/plan-annotation-corr/Bathroom/Dual-sink-red.svg';
SourcesBathroom['ShowerCabin'] = '/images/plan-annotation-corr/Bathroom/Shower-cabin1-red.svg';
SourcesBathroom['ShowerCabin2'] = '/images/plan-annotation-corr/Bathroom/Shower-cabin2-red.svg';
SourcesBathroom['ShowerCabin3'] = '/images/plan-annotation-corr/Bathroom/Shower-cabin3-red.svg';
SourcesBathroom['ShowerHead'] = '/images/plan-annotation-corr/Bathroom/Shower-head-red.svg';
SourcesBathroom['SinkCommodity'] = '/images/plan-annotation-corr/Bathroom/Sink-commodity-red.svg';
SourcesBathroom['Sink'] = '/images/plan-annotation-corr/Bathroom/Sink-red.svg';
SourcesBathroom['Toilet'] = '/images/plan-annotation-corr/Bathroom/Toilet-red.svg';
SourcesBathroom['TowelDryer'] = '/images/plan-annotation-corr/Bathroom/Towel-dryer-red.svg';
SourcesBathroom['Tumbler'] = '/images/plan-annotation-corr/Bathroom/Tumbler-red.svg';
SourcesBathroom['Washer'] = '/images/plan-annotation-corr/Bathroom/Washer-red.svg';

DragSourcesCorr['Bathroom'] = SourcesBathroom;

// Indoors

SourcesIndoors['AtticHatch'] = '/images/plan-annotation-corr/Indoors/Attic-hatch-red.svg';
SourcesIndoors['BoilerHeater'] = '/images/plan-annotation-corr/Indoors/Boiler-heater-red.svg';
SourcesIndoors['Boiler'] = '/images/plan-annotation-corr/Indoors/Boiler-red.svg';
SourcesIndoors['CentralVacuum'] = '/images/plan-annotation-corr/Indoors/Central-vacuum-red.svg';
SourcesIndoors['DistrictHeating'] = '/images/plan-annotation-corr/Indoors/District-heating-red.svg';
SourcesIndoors['DryerWasherPillar'] =
    '/images/plan-annotation-corr/Indoors/Dryer-washer-pillar-red.svg';
SourcesIndoors['DryerWasher'] = '/images/plan-annotation-corr/Indoors/Dryer-washer-red.svg';
SourcesIndoors['DryingCabinet'] = '/images/plan-annotation-corr/Indoors/Drying-cabinet-red.svg';
SourcesIndoors['Electricity'] = '/images/plan-annotation-corr/Indoors/Electricity-red.svg';
SourcesIndoors['Fireplace'] = '/images/plan-annotation-corr/Indoors/Fireplace-red.svg';
SourcesIndoors['GeothermalHeater'] =
    '/images/plan-annotation-corr/Indoors/Geothermal-heater-red.svg';
SourcesIndoors['HatRack'] = '/images/plan-annotation-corr/Indoors/Hat-rack-red.svg';
SourcesIndoors['LinenCupboard'] = '/images/plan-annotation-corr/Indoors/Linen-cupboard-red.svg';
SourcesIndoors['Shelf'] = '/images/plan-annotation-corr/Indoors/Shelf-red.svg';
SourcesIndoors['SkylightWindow'] = '/images/plan-annotation-corr/Indoors/Skylight-window-red.svg';
SourcesIndoors['Stove'] = '/images/plan-annotation-corr/Indoors/Indoor-stove-red.svg';
SourcesIndoors['TiledStove'] = '/images/plan-annotation-corr/Indoors/Tiled-stove-red.svg';
SourcesIndoors['Tumbler'] = '/images/plan-annotation-corr/Indoors/Tumbler-red.svg';
SourcesIndoors['Wardrobe'] = '/images/plan-annotation-corr/Indoors/Wardrobe-red.svg';
SourcesIndoors['WardrobeSlidingDoors'] =
    '/images/plan-annotation-corr/Indoors/Wardrobe-sliding-doors-red.svg';
SourcesIndoors['Washer'] = '/images/plan-annotation-corr/Indoors/Washer-red.svg';
SourcesIndoors['WaterHeater'] = '/images/plan-annotation-corr/Indoors/Water-heater-red.svg';
SourcesIndoors['Window'] = '/images/plan-annotation-corr/Indoors/Window-red.svg';

DragSourcesCorr['Indoors'] = SourcesIndoors;

// Kitchen

SourcesKitchen['CabinetCounterShelf'] =
    '/images/plan-annotation-corr/Kitchen/Cabinet-counter-shelf-red.svg';
SourcesKitchen['Cabinet'] = '/images/plan-annotation-corr/Kitchen/Cabinet-red.svg';
SourcesKitchen['CleaningCabinet'] = '/images/plan-annotation-corr/Kitchen/Cleaning-cabinet-red.svg';
SourcesKitchen['CookerHood'] = '/images/plan-annotation-corr/Kitchen/Cooker-hood-red.svg';
SourcesKitchen['Counter'] = '/images/plan-annotation-corr/Kitchen/Counter-red.svg';
SourcesKitchen['Dishwasher'] = '/images/plan-annotation-corr/Kitchen/Dishwasher-red.svg';
SourcesKitchen['DoubleKitchenSink'] =
    '/images/plan-annotation-corr/Kitchen/Double-kitchen-sink-red.svg';
SourcesKitchen['Freezer'] = '/images/plan-annotation-corr/Kitchen/Freezer-red.svg';
SourcesKitchen['FridgeFreezer'] = '/images/plan-annotation-corr/Kitchen/Fridge-freezer-red.svg';
SourcesKitchen['Fridge'] = '/images/plan-annotation-corr/Kitchen/Fridge-red.svg';
SourcesKitchen['HighCabinet'] = '/images/plan-annotation-corr/Kitchen/High-cabinet-red.svg';
SourcesKitchen['KitchenCounterWithTopCabinet'] =
    '/images/plan-annotation-corr/Kitchen/Kitchen-counter-with-top-cabinet-red.svg';
SourcesKitchen['KitchenIsland'] = '/images/plan-annotation-corr/Kitchen/Kitchen-island-red.svg';
SourcesKitchen['Micro'] = '/images/plan-annotation-corr/Kitchen/Micro-red.svg';
SourcesKitchen['OvenMicro'] = '/images/plan-annotation-corr/Kitchen/Oven-Micro-red.svg';
SourcesKitchen['Oven'] = '/images/plan-annotation-corr/Kitchen/Oven-red.svg';
SourcesKitchen['Pantry'] = '/images/plan-annotation-corr/Kitchen/Pantry-red.svg';
SourcesKitchen['RoundKitchenSink'] =
    '/images/plan-annotation-corr/Kitchen/Round-kitchen-sink-red.svg';
SourcesKitchen['SingleKitchenSink'] =
    '/images/plan-annotation-corr/Kitchen/Single-kitchen-sink-red.svg';
SourcesKitchen['Stove'] = '/images/plan-annotation-corr/Kitchen/Stove-red.svg';
SourcesKitchen['WineCooler'] = '/images/plan-annotation-corr/Kitchen/Wine-cooler-red.svg';

DragSourcesCorr['Kitchen'] = SourcesKitchen;

// Outdoors

SourcesStairs['StairStep'] = '/images/plan-annotation-corr/Stairs/Stair-step-red.svg';
SourcesStairs['StairsL1'] = '/images/plan-annotation-corr/Stairs/Stairs-L-1-red.svg';
SourcesStairs['StairsL2'] = '/images/plan-annotation-corr/Stairs/Stairs-L-2-red.svg';
SourcesStairs['Stairs'] = '/images/plan-annotation-corr/Stairs/Stairs-red.svg';
SourcesStairs['StairsRound'] = '/images/plan-annotation-corr/Stairs/Stairs-round-red.svg';
SourcesStairs['StairsS'] = '/images/plan-annotation-corr/Stairs/Stairs-S-red.svg';

DragSourcesCorr['Stairs'] = SourcesStairs;

export const DragSVGCorr = DragSourcesCorr;
